import { Component, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { WatchStorageService } from './services/watchstorage.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {
  isCollapsed = false;
  isAuth = localStorage.getItem('token');
  constructor(
    private renderer: Renderer2,
    private router: Router,
    private watchStorage: WatchStorageService
  ) {
    const url = window.location.pathname;
    if (!this.isAuth) {
      if (
        url &&
        !String(url).includes('privacy-policy') &&
        !String(url).includes('terms-conditions')
      ) {
        // this.router.navigate(['/login']);
      }
    }

    window.onload = () => {
      const ele = document.querySelector('.loader');
      if(ele) this.renderer.addClass(ele, 'hidden');
    };
    this.watchStorage.watchStorage().subscribe(res => {
      if (res) {
        this.isAuth = localStorage.getItem('token');
      }
    });
  }
  checkMenuShow(event) {
    this.isCollapsed = event;
  }
}
